import Create from "./Create";
import Update from "./Update";
import Search from "./Search";
import Filter from "./Filter";
import Body from "./Body";
import ShowInfoTicket from "./ShowTicket";

const Components = {
  Create,
  Update,
  Search,
  Filter,
  Body,
  ShowInfoTicket,
};

export default Components;
